import { authSessionStore } from "@/features/auth/stores/auth-session.store";

/**
 * Resolve the disclosureId string from an assignment object.
 * The disclosureId may be a populated object or a plain string.
 */
export const resolveDisclosureId = (assignment) => {
  const disc = assignment?.disclosureId;
  return typeof disc === "object" ? disc?._id : disc;
};

/**
 * Check if the current user can edit a disclosure based on assignment state.
 * - No assignment → editable
 * - Assigned to current user → editable
 * - Super admin → always editable
 * - Otherwise → read-only
 */
export const canEditDisclosure = (assignment) => {
  const user = authSessionStore.user;
  if (!assignment) return true;
  return assignment.assignedToUserId?._id === user?.userId;
};

/**
 * Check if a disclosure is assigned to the current user.
 */
export const isAssignedToMe = (assignment) => {
  if (!assignment) return false;
  const user = authSessionStore.user;
  return assignment.assignedToUserId?._id === user?.userId;
};

/**
 * Get display name for an assignee.
 */
export const getAssigneeDisplayName = (assignment) => {
  if (!assignment) return null;
  const user = assignment.assignedToUserId;
  if (user?.name) return user.name;
  return assignment.assignedToEmail;
};
